import React, { useEffect, useState } from "react";
import { Modal, Box, Typography } from "@mui/material";
import ApiConfig from "../config/ApiConfig";
import { MILLISECONDS_PER_MINUTE } from "../util/constants";

const StatusCheck = () => {
  const [showModal, setShowModal] = useState(false); // Manage modal visibility
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  useEffect(() => {
    const statusUrl = new URL(
      ApiConfig.protocol + ApiConfig.apiUri + ApiConfig.irqEndpoint + "/status"
    );

    const callStatusCheck = async () => {
      try {
        const response = await fetch(statusUrl);
        const responseJson = await response.json();
        return responseJson.status;
      } catch (error) {
        console.error(error);
        return null;
      }
    };

    const checkStatus = async () => {
      const statusDate = localStorage.getItem("statusCheckTime");
      let statusCheckStale = true;

      if (statusDate) {
        const millisecondsDiff = Date.now() - statusDate;
        const minutesDiff = Math.round(
          millisecondsDiff / MILLISECONDS_PER_MINUTE
        );
        statusCheckStale = minutesDiff > 10;
      }

      if (statusCheckStale) {
        const statusCheckResult = await callStatusCheck();
        localStorage.setItem("statusCheckTime", Date.now());

        if (statusCheckResult === "UP") {
          localStorage.setItem("statusCheckStatus", true);
          setShowModal(false);
        } else {
          localStorage.setItem("statusCheckStatus", false);
          setShowModal(true);
        }
      } else {
        const cachedStatus =
          localStorage.getItem("statusCheckStatus") === "true";
        setShowModal(!cachedStatus);
      }
    };

    checkStatus();
  }, []); // Empty dependency array ensures this runs once after the component mounts

  return (
    <Modal
      open={showModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Unable to process quotes at this time
        </Typography>
        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
          Services are currently unavailable. Please try again soon.
        </Typography>
      </Box>
    </Modal>
  );
};

export default StatusCheck;
